import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { IState } from "../reducers";
import * as fromApp from "./app";
import * as fromAudio from "./audio";
import * as fromAuth from "./auth";
import * as fromCollection from "./collection";
import * as fromDirector from "./director";
import * as fromEvent from "./event";
import * as fromFooter from "./footer";
import * as fromForm from "./form";
import * as fromGallery from "./gallery";
import * as fromHonorU from "./honoru";
import * as fromMarket from "./market";
import * as fromPeerSupport from "./peerSupport";
import * as fromStream from "./stream";
import * as fromStripe from "./stripe";
import * as fromSubscription from "./subscription";

export type ActionType =
	| fromApp.AppActionTypes
	| fromAudio.AudioActionTypes
	| fromAuth.AuthActionTypes
	| fromFooter.FooterActionTypes
	| fromForm.FormActionTypes
	| fromGallery.GalleryActionTypes
	| fromCollection.CollectionActionTypes
	| fromDirector.DirectorActionTypes
	| fromEvent.EventActionTypes
	| fromHonorU.HonorUActionTypes
	| fromMarket.MarketActionTypes
	| fromPeerSupport.PeerSupportActionTypes
	| fromStream.StreamActionTypes
	| fromStripe.StripeActionTypes
	| fromSubscription.SubscriptionActionTypes;

export interface IAction {
	type: ActionType;
	payload?: any;
	params?: any;
}
// TODO
// export interface IAPIRequestAction extends IAction {
// 	apiRequest: IAPIRequest;
// }
export type AppThunkResult<R> = ThunkAction<R, IState, undefined, IAction>;
export type AppThunkDispatch = ThunkDispatch<IState, undefined, IAction>;

export function getStoreDispatcher(store: keyof IState) {
	switch (store) {
		case "appStore":
			return fromApp.mapAppDispatchToProps;
		case "audioStore":
			return fromAudio.mapAudioDispatchToProps;
		case "authStore":
			return fromAuth.mapAuthDispatchToProps;
		case "footerStore":
			return fromFooter.mapFooterDispatchToProps;
		case "formStore":
			return fromForm.mapFormDispatchToProps;
		case "galleryStore":
			return fromGallery.mapGalleryDispatchToProps;
		case "collectionStore":
			return fromCollection.mapCollectionDispatchToProps;
		case "directorStore":
			return fromDirector.mapDirectorDispatchToProps;
		case "eventStore":
			return fromEvent.mapEventDispatchToProps;
		case "honorUStore":
			return fromHonorU.mapHonorUDispatchToProps;
		case "marketStore":
			return fromMarket.mapMarketDispatchToProps;
		case "peerSupportStore":
			return fromPeerSupport.mapPeerSupportDispatchToProps;
		case "streamStore":
			return fromStream.mapStreamDispatchToProps;
		case "stripeStore":
			return fromStripe.mapStripeDispatchToProps;
		case "subscriptionStore":
			return fromSubscription.mapSubscriptionDispatchToProps;
	}
}

export type IStoreDispatch = {
	appStoreDispatch: ReturnType<typeof fromApp.mapAppDispatchToProps>;
	audioStoreDispatch: ReturnType<typeof fromAudio.mapAudioDispatchToProps>;
	authStoreDispatch: ReturnType<typeof fromAuth.mapAuthDispatchToProps>;
	footerStoreDispatch: ReturnType<typeof fromFooter.mapFooterDispatchToProps>;
	formStoreDispatch: ReturnType<typeof fromForm.mapFormDispatchToProps>;
	galleryStoreDispatch: ReturnType<typeof fromGallery.mapGalleryDispatchToProps>;
	collectionStoreDispatch: ReturnType<typeof fromCollection.mapCollectionDispatchToProps>;
	directorStoreDispatch: ReturnType<typeof fromDirector.mapDirectorDispatchToProps>;
	eventStoreDispatch: ReturnType<typeof fromEvent.mapEventDispatchToProps>;
	honoruStoreDispatch: ReturnType<typeof fromHonorU.mapHonorUDispatchToProps>;
	marketStoreDispatch: ReturnType<typeof fromMarket.mapMarketDispatchToProps>;
	peerSupportStoreDispatch: ReturnType<typeof fromPeerSupport.mapPeerSupportDispatchToProps>;
	streamStoreDispatch: ReturnType<typeof fromStream.mapStreamDispatchToProps>;
	stripetoreDispatch: ReturnType<typeof fromStripe.mapStripeDispatchToProps>;
	subscriptionStoreDispatch: ReturnType<typeof fromSubscription.mapSubscriptionDispatchToProps>;
};

export type ICustomStoreConnectedProps = Partial<IState> & Partial<IStoreDispatch> & RouteComponentProps;

export const connectCustom = <P>(
	componentType: React.ComponentType<Partial<IState> & Partial<IStoreDispatch> & P & any>,
	stores: (keyof IState)[],
	router?: boolean
) => {
	const connected = connect<Partial<IState>, Partial<IStoreDispatch>, any, any>(
		(state: IState, props: P): Partial<IState> => {
			let customState = {};
			stores.forEach((store: keyof IState) => {
				customState[store] = state[store];
			});
			return customState;
		},
		(dispatch: AppThunkDispatch): Partial<IStoreDispatch> => {
			let customDispatch = {};
			stores.forEach((store: keyof IState) => {
				customDispatch[store + "Dispatch"] = getStoreDispatcher(store)(dispatch);
			});
			return customDispatch;
		}
	)(componentType);

	if (router) return withRouter<ICustomStoreConnectedProps & P, any>(connected);
	return connected;
};
